export default import.meta.ROLLDOWN_FILE_URL_Z7pCBPISBeXeUjAujdQJ6w